import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
import type { Lang } from '../types/content';
const options: {
  value: Lang;
  short: string;
  full: string;
}[] = [{
  value: 'en',
  short: 'EN',
  full: 'English'
}, {
  value: 'es',
  short: 'ES',
  full: 'Español'
}];
export function LanguageToggle({
  variant = 'compact'
}: {
  variant?: 'compact' | 'full';
}) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div role="group" aria-label={t(ui.language)} className="flex items-center rounded-lg bg-white/10 p-1" data-id="element-227" data-mp="25g362dqwptg3">
      {options.map(o => {
      const active = o.value === lang;
      return <button key={o.value} type="button" lang={o.value} onClick={() => setLang(o.value)} aria-pressed={active} aria-label={o.full} className={`rounded-md px-2.5 py-1.5 text-xs font-bold tracking-wide transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white ${active ? 'bg-white text-navy' : 'text-navy-soft hover:text-white'}`} data-id="element-228" data-mp="2fa2533voox3t">
            {variant === 'full' ? o.full : o.short}
          </button>;
    })}
    </div>;
}